
import React, { useState } from 'react';
import styles from './index.module.css';
import InvoiceTable from './components/InvoiceTable';

const AllInvoice = () => {
  const [activeSection, setActiveSection] = useState('all');

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.sectionTabs}>
          <button
            className={`${styles.tabButton} ${activeSection === 'all' ? styles.tabButtonActive : ''}`}
            onClick={() => setActiveSection('all')}
          >
           All Invoices 
          </button>
        </div>

        {activeSection === 'all' && (
          <div className={styles.sectionContent}>
            <InvoiceTable />
          </div>
        )}
      </div>
    </div>
  );
};

export default AllInvoice;